import React, { useState, useRef } from "react";
import csvIcon from "../assets/images/csv.png";
import { useTranslation } from "react-i18next";

const ImportPopup = (props) => {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = () => {
    if (file) {
      props.closePopup(null, true, file, props.impValue);
    } else {
      alert(t("please_select_file_before_uploading_txt"));
    }
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Programmatically trigger the file input click event
    }
  };

  return (
    <div className="product-import-pop">
      <div className="product-import-pop-overlay"></div>
      <div className="product-import-wrap">
        <span
          className="close-import-pop"
          onClick={() => props.closePopup(null, false, null, null)}
        ></span>

        <div className="product-import-body">
          <div className="product-import-header">
            <h3>{t("import_txt")} {props.impValue} {t("by_csv_txt")}</h3>
          </div>
          <div className="product-import-content">
            {file && (
              <div className="file-added">
                <p>{t("added_file_txt")}</p>
              </div>
            )}
            {!file && (
              <div className="custom-file-add">
                <div className="custom-file" onClick={triggerFileInput}>
                  <span>{t("add_file_txt")}</span>
                  <input
                    type="file"
                    className="custom-file-input"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    style={{ display: "none" }}
                  />
                </div>
              </div>
            )}
            {file && (
              <div className="custom-file-choose">
                <p>
                  <span className="file-icon">
                    <img src={csvIcon} />
                  </span>
                  {file.name}
                </p>
                <button onClick={triggerFileInput}>{t("replace_file_txt")}</button>
                <input
                  type="file"
                  className="custom-file-input"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  style={{ display: "none" }} // Hide the file input element
                />
              </div>
            )}
          </div>
          <div className="product-import-bottom">
            <button
              className="button cancel-btn"
              onClick={() => props.closePopup(null, false, null, null)}
            >
              {t("cancel_txt")}
            </button>
            <button
              className={`button upload-btn ${!file ? "disabled" : "active"}`}
              onClick={handleUpload}
              disabled={!file}
            >
              {t("upload_and_continue_txt")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportPopup;
